// Steps to deploy this app using aws cli:
// 1, Configure an aws profile named citra-dev
// 2, Go to root director on this folder on terminal
// 3. npm run build
// 4, aws --profile mua-reg s3 sync build/ s3://app.ventia.mu.reg

export const AWS_API = 'https://7ggocj6867.execute-api.ap-southeast-2.amazonaws.com';
export const region = 'ap-southeast-2';
export const userPoolId = 'ap-southeast-2_nUyJoB5Po';
export const userPoolClientId = '50ev3bnkdh6t6futh5aanqql39';
